import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const UserCircle: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 24)} fill="none">
            <Path
                d="M12 21a9 9 0 100-18 9 9 0 000 18zm0 0a8.958 8.958 0 004.94-1.476c.04-.22.06-.457.06-.711C17 16.155 14.761 14 12 14s-5 2.155-5 4.813c0 .255.02.491.06.711A8.958 8.958 0 0012 21zm3.177-11.912a3.088 3.088 0 11-6.177 0 3.088 3.088 0 016.177 0z"
                stroke={props.color}
            />
        </Svg>
    );
};

export default React.memo(UserCircle);
